export type PartialMessageProps = {
  className?: string;
  text: string;
  isBold?: boolean;
  url?: string;
};

export const PartialMessageConstructor = ({
  className = '',
  text = '',
  url = '',
  isBold = false,
}: Partial<PartialMessageProps> = {}): PartialMessageProps => ({
  className: String(className),
  text: String(text),
  url: String(url),
  isBold: Boolean(isBold),
});
